import { FC, useState } from 'react';
import { useRevenuePools } from '../../hooks/useRevenuePools';
import { Button, TableCell, TableRow } from '@mui/material';
import { LaunchpadTable } from '../../components/mui-overrides/LaunchpadTable';
import { Routes } from '../../router/Routes';
import { Link, useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import { EmptyTable } from '../../components/utils/EmtpyTable';
import { useTranslation } from 'react-i18next';

const initialPage = 0;
const initialRowsPerPage = 25;

export const RevenuePoolsTable: FC = () => {
  const { t } = useTranslation();
  const [page, setPage] = useState(initialPage);
  const [rowsPerPage, setRowsPerPage] = useState(initialRowsPerPage);
  const revenuePools = useRevenuePools({ page, rowsPerPage }, t);
  const navigate = useNavigate();

  return (
    <LaunchpadTable
      hidePagination={false}
      page={page}
      rowsPerPage={rowsPerPage}
      setPage={setPage}
      setRowsPerPage={(rowsPerPage) => {
        setPage(initialPage);
        setRowsPerPage(rowsPerPage);
      }}
      useCardStyles={false}
      length={revenuePools.count}
      renderHeader={() => (
        <TableRow>
          <TableCell>{t('revenuePools.overview.table.title.properties.title')}</TableCell>
          <TableCell></TableCell>
        </TableRow>
      )}
      renderRows={() => {
        if (revenuePools.items.length === 0) {
          return <EmptyTable bottomText={t('general.errors.noItemsFound')} />;
        }
        return (
          <>
            {revenuePools.items.map((row, index) => (
              <TableRow key={index} hover style={{ cursor: 'pointer', textDecoration: 'none' }}>
                <TableCell>{row.title}</TableCell>
                <TableCell>
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    {row.fileUrl && (
                      <Link to={row.fileUrl} target="_blank">
                        <Button sx={{ mr: 2 }} variant="contained" size="small" disableElevation>
                          {t('revenuePools.overview.table.openAttachment')}
                        </Button>
                      </Link>
                    )}
                    <Button
                      variant="contained"
                      size="small"
                      disableElevation
                      color="primary"
                      onClick={() => navigate(Routes.REVENUE_POOLS.EDIT.replace(':poolId', (row as any)._id || ''))}
                    >
                      {t('revenuePools.overview.table.editRow')}
                    </Button>
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </>
        );
      }}
    />
  );
};
